'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.computeTimeDomain = undefined;
var _isNull2 = require('lodash/isNull');
var _isNull3 = _interopRequireDefault(_isNull2);
var _max3 = require('lodash/max');
var _max4 = _interopRequireDefault(_max3);
var _min3 = require('lodash/min');
var _min4 = _interopRequireDefault(_min3);
var _last2 = require('lodash/last');
var _last3 = _interopRequireDefault(_last2);
var _head2 = require('lodash/head');
var _head3 = _interopRequireDefault(_head2);
var _time = require('./time');
Object.defineProperty(exports, 'computeTimeDomain', {
  enumerable: true,
  get: function get() {
    return _time.computeTimeDomain;
  }
});
exports.computeLinearScale = computeLinearScale;
exports.computeLinearDomain = computeLinearDomain;
exports.computeLinearAxis = computeLinearAxis;
exports.computeOrdinalScale = computeOrdinalScale;
exports.computeOrdinalAxis = computeOrdinalAxis;
exports.computeTimeScale = computeTimeScale;
exports.computeTimeAxis = computeTimeAxis;
exports.computeAreaIndex = computeAreaIndex;
exports.computeOffset = computeOffset;
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
var _d = require('d3');
var _d2 = _interopRequireDefault(_d);
var _utils = require('../utils/');
var _linear = require('./linear');
var _linearDomain = require('./linear-domain');
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function computeLinearScale(range, domain) {
  return _d2.default.scale.linear().range(range).domain(domain);
}
function computeLinearDomain(options, data, datumAccessor) {
  var extent = _d2.default.extent(data, datumAccessor);
  var _ref = [(0, _min4.default)([(0, _head3.default)(extent), options.linear.min]), (0, _max4.default)([(0, _last3.default)(extent), options.linear.max])],
    min = _ref[0],
    max = _ref[1];
  var pivot = options.linear.pivot.value;
  if (!(0, _isNull3.default)(pivot)) {
    if (pivot < min) min = pivot;
    if (pivot > max) max = pivot;
  }
  if (min === max) {
    var delta = Math.abs(min);
    var _ref2 = [min - delta, min + delta];
    min = _ref2[0];
    max = _ref2[1];
  }
  return (0, _linearDomain.refineLinearDomain)([min, max]);
}
function computeLinearAxis(scale, pivot, options) {
  var range = scale.range();
  var domain = scale.domain();
  var ticks = (0, _linear.computeLinearTicks)({
    range: range,
    domain: domain,
    options: options
  });
  return _d2.default.svg.axis().scale(scale).orient(options.orient).tickSize(options.tick.size, options.tick.size).tickFormat((0, _utils.getFormat)(options.format)).tickValues(ticks);
}
;
function computeOrdinalScale(options, interval, values) {
  return _d2.default.scale.ordinal().domain(values).rangeBands(interval, options.gap, options.padding);
}
function getOrdinalTickValues(scale, options) {
  var size = options.baseSize;
  var min = options.ordinal.minDisplaySize;
  return size >= min && options.tick.display ? scale.domain() : [];
}
function computeOrdinalAxis(scale, options) {
  return _d2.default.svg.axis().scale(scale).orient(options.orient).tickSize(options.tick.size, options.tick.size).tickFormat((0, _utils.getFormat)(options.format)).tickValues(getOrdinalTickValues(scale, options));
}
function computeTimeScale(range, domain) {
  return _d2.default.time.scale.utc().range(range).domain(domain);
}
function computeTimeAxis(scale, pivot, options) {
  var range = scale.range();
  var domain = scale.domain();
  var rangeDelta = Math.abs(range[1] - range[0]) + 1;
  var min = options.ordinal.minDisplaySize;
  if (rangeDelta < min) {
    return _d2.default.svg.axis().scale(scale).orient(options.orient).tickSize(options.tick.size, options.tick.size).tickFormat((0, _utils.getFormat)(options.format)).tickValues([]);
  }
  var _computeTimeSteps = (0, _time.computeTimeSteps)({
      range: range,
      domain: domain,
      options: options
    }),
    minorStep = _computeTimeSteps.minorStep;
  var frequency = R.pathOr('year', ['linear', 'frequency'], options);
  var freq = R.has(frequency, _d2.default.time) ? frequency : 'year';
  return _d2.default.svg.axis().scale(scale).orient(options.orient).tickSize(options.tick.size, options.tick.size).tickFormat((0, _utils.getFormat)(options.format)).tickValues((0, _time.computeTimeTicks)({
    domain: domain,
    minorStep: minorStep,
    options: options
  }));
}
function computeAreaIndex(areaIndex, domain, domainIndex) {
  return domainIndex - (0, _utils.getDomainDelta)(domain) * areaIndex;
}
function computeOffset(size, start, end) {
  return (start + size - end) / 2 - start;
}